<template>
<div class="chapter">
<div class="inner_page">
<p class="center"><a id="page_ix"></a>For Jenny Liosatou and Giulio D’Alessio</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedi.vue?290cb620